import { render, staticRenderFns } from "./ReferralSearch.vue?vue&type=template&id=17b21fb0&"
import script from "./ReferralSearch.vue?vue&type=script&lang=ts&"
export * from "./ReferralSearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports